export enum StepKey {
    Vehicle = 1,
    Pickup = 2,
    Catalog = 3,
    DateTime = 4,
    Extras = 5,
    Overview = 6
  }
  
  export const StepperSteps = [
    { number: StepKey.Vehicle, label: 'step-your-vehicle' },
    { number: StepKey.Pickup, label: 'step-pickup' },
    { number: StepKey.Catalog, label: 'step-products' },
    { number: StepKey.DateTime, label: 'step-datetime' },
    { number: StepKey.Extras, label: 'step-extras' },
    { number: StepKey.Overview, label: 'step-summary' }
  ];
  